import request from 'superagent'
import {
    FLOWERAI_CLOUD_DEVICE_LIST,
    FLOWERAI_CLOUD_SENSOR,
    FLOWERAI_CLOUD_VALVE
} from '../constants/urls'

export const GET_DEVICE = 'GET_DEVICE'
export function getDevice(uuid, type = 'sensor', language = 'de-DE') {
    const basePath = type === 'sensor' ? FLOWERAI_CLOUD_SENSOR : FLOWERAI_CLOUD_VALVE

    const req = request
        .get(basePath.replace(':uuid', uuid))
        .query({
            country: language,
        })
        .auth('admin', 'supersecret')

    return {
        type: GET_DEVICE,
        payload: req,
    }
}

export const RESET_DEVICE_ERROR = 'RESET_DEVICE_ERROR'
export function resetDeviceError() {
    return {
        type: RESET_DEVICE_ERROR,
        payload: null,
    }
}

export const GET_DEVICE_LIST = 'GET_DEVICE_LIST'
export function getDeviceList(language = 'de-DE') {
    const req = request
        .get(FLOWERAI_CLOUD_DEVICE_LIST)
        .query({
            country: language,
        })
        .auth('admin', 'supersecret')

    return {
        type: GET_DEVICE_LIST,
        payload: req,
    }
}



// WEBPACK FOOTER //
// ./src/actions/devices.js